module.exports = __webpack_public_path__ + "img/temp.64b64652.svg";